import phone from 'phone'

export default function validate(questions, answers, setValidationErrors, campaignType = null, channel = '') {
  const validationErrors = []

  questions.forEach(q => {
    if (!q.active) return
    if (!q.question || q.question === '') {
      validationErrors.push('One of your questions has an empty title')
    }
    if (q.questionType === 'postcode') {
      const settings = q.settings || {}
      const allowedCountries = settings.allowedCountries || []

      if (allowedCountries.length === 0) {
        validationErrors.push("Please select at least one allowed country for postcode question")
      }
    }
    if (['multiple_choice', 'multiple_select'].includes(q.questionType)) {
      const multipleChoiceAnswers = answers.filter(a => a.active && String(a.questionId) === String(q.id) && a.answer)

      if (multipleChoiceAnswers.length <= 1) {
        validationErrors.push("One of your questions has one or zero answers")
      } else if (_.uniq(multipleChoiceAnswers.map(a => a.answer)).length < multipleChoiceAnswers.length) {
        validationErrors.push("Two of the answers on a question are the same")
      } else if (multipleChoiceAnswers.length > 9 && channel === 'whatsapp') {
        validationErrors.push("One of your questions has more than 9 answers: WhatsApp allows a maximum of 9 per question")
      }
    }
    if (campaignType === 'sms_survey' && q.digitOrder === 1 && q.questionType === 'instruction') {
      validationErrors.push("You cannot have an instruction as the first question in an SMS survey")
    }

    if (q.questionType === 'opt_in_radio') {
      if (!q.settings.topics || q.settings.topics.length === 0) {
        validationErrors.push("An opt-in question is missing topics")
      }
    }

    if (q.questionType === 'send_sms') {
      if ((q.settings.textMessageBody || '').length < 3) {
        validationErrors.push("An SMS question is missing text message content")
      }
    }
    if (q.questionType === 'transfer') {
      const phoneNumber = q.settings.toPhoneNumber
      if (!phoneNumber || phoneNumber.trim() === '') {
        validationErrors.push("A call transfer is missing a phone number")
      } else {
        const formatted = phone(phoneNumber)
        if (!formatted.isValid) {
          validationErrors.push("A call transfer has an invalid phone number")
        }
      }
    }

    if (q.questionType === 'score') {
      if (q.settings.min >= q.settings.max) {
        validationErrors.push("Score question min must be less than the max")
      }
      if (q.settings.max <= q.settings.min) {
        validationErrors.push("Score question max must be greater than the min")
      }
      if (q.settings.default < q.settings.min || q.settings.default > q.settings.max) {
        validationErrors.push("Score question default must be between the min and max")
      }
    }

    if (q.questionType === 'long_text') {
      const settings = q.settings || {}
      const numberOfRows = settings.numberOfRows || []

      if (numberOfRows < 1 || numberOfRows > 30) {
        validationErrors.push("Long text question rows must be between 1 and 30")
      }
    }
  })

  setValidationErrors(_.uniq(validationErrors))
}
